import { Directive, TemplateRef } from '@angular/core';

@Directive({
  selector: '[wlProgressiveFormBody]',
  standalone: true,
})
export class ProgressiveFormBodyDirective {
  constructor(public templateRef: TemplateRef<unknown>) {}
}
